import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";
import { Link } from "gatsby";

function Trustedcompany(props) {
  return (
    <div className="trusted_company p-100">
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={12} lg={6} xl={6} xxl={6} className="my-auto">
            <h2>
              Revolutionize Your Business with TekRevol’s Top Android App
              Developers Company in London
            </h2>
            <p>
              TekRevol stands out among Android app development companies in
              London, offering a practical and impactful approach to elevate
              your business. As your trusted Android app development agency in
              London, we focus on delivering top-notch solutions tailored to
              your needs.
            </p>
            <p>
              Partner with TekRevol to revolutionize your business with our
              expertise in Android app development.
            </p>
            <p>
              Our dedicated team ensures that your Android app not only meets
              but exceeds expectations, positioning your business for success in
              the competitive London market.
            </p>
            <Link
              to="/contact"
              className="border_btn dark_btn"
              aria-label="TekRevol Contact"
              rel="noopener"
            >
              Let's Connect!
            </Link>
          </Col>
          <Col xs={12} md={12} lg={6} xl={6} xxl={6} className="my-auto">
            <div className="trustedimg">
              <StaticImage
                src="../../../images/location_new/fold11/Uk.webp"
                alt="Android-app-development-companies-london"
                layout="constrained"
                placeholder="blurred"
                formats={["webp"]}
                width={775}
                height={670}
              />
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Trustedcompany;
